const HYDRATE_EVENT = 'NOTIFY_ME_SLIDEOUT_HYDRATE'

class NotifyMeSlideout extends HHBaseElement {
  constructor() {
    super()

    this.productForm = this.querySelector('#slideout-notify-me-form')
    this.emailInput = this.querySelector('#slideout-notify-me-email')
    this.skuInput = this.querySelector('#slideout-notify-me-sku')
    this.productIdInput = this.querySelector('#slideout-notify-me-product-id')
    this.newsletterInput = this.querySelector('#slideout-notify-me-nesletter')
    this.atcButton = this.querySelector('.js-slideout-notify-me-atc')
    this.featuredImage = this.querySelector('.js-slideout-notify-me-image')
    this.productTitle = document.querySelector('.js-slideout-notify-me-title')
    this.variantIdInput = this.querySelector(
      '.js-slideout-notify-me-variant'
    )
    this.subscribeStatusCheckbox = this.querySelector(
      '#slideout-notify-me-nesletter'
    )
    this.sendNotifyMeRequest = this.sendNotifyMeRequest.bind(this)
    this.hydrateSlideoutContent = this.hydrateSlideoutContent.bind(this)
  }

  connectedCallback() {
    this.productForm.addEventListener(
      'submit',
      this.sendNotifyMeRequest.bind(this)
    )
    this.addEventListener(HYDRATE_EVENT, this.hydrateSlideoutContent)
    this.setAttribute('initialized', 'true');
  }

  disconnectedCallback() {
    this.productForm.removeEventListener('submit', this.sendNotifyMeRequest)
    this.removeEventListener(HYDRATE_EVENT, this.hydrateSlideoutContent)
  }

  hydrateSlideoutContent(e) {
    const { variantId, variantSku, productId, productTitle, featuredImage } =
      e.detail

    if (variantId && this.variantIdInput) {
      this.variantIdInput.value = variantId
    }
    if (variantSku && this.skuInput) {
      this.skuInput.value = variantSku
    }
    if (productId && this.productIdInput) {
      this.productIdInput.value = productId
    }
    if (productTitle && this.productTitle) {
      this.productTitle.innerHTML = productTitle
    }
    if (featuredImage && this.featuredImage) {
      this.featuredImage.innerHTML = `<img src="${featuredImage}" alt="${productTitle}" />`
    }
  }

  async sendNotifyMeRequest(e) {
    e.preventDefault()
    const triggerButton = this.atcButton

    try {
      if (triggerButton) {
        triggerButton.setAttribute('loading', true)
      }
      let subscribedValue = null
      if (this.subscribeStatusCheckbox.checked) {
        subscribedValue = 'subscribed'
      }

      const auth_data = { email: this.emailInput.value }
      const contact_data = {
        opt_in_source: 'back_in_stock_modal',
        ...(subscribedValue
          ? {
              channels: { email: { subscribeStatus: subscribedValue } },
            }
          : {}),
      }
      await crdl('contact', auth_data, contact_data)

      const properties = {
        sku: this.skuInput.value,
        productID: this.productIdInput.value,
      }
      await crdl('event', 'back_in_stock_signup', properties)
    } finally {
      if (triggerButton) {
        triggerButton.removeAttribute('loading')
      }

      this.closest('slide-panel')
        ._shadowRoot.querySelector('.slide-panel__backdrop')
        .click()
    }
  }
}

window.customElements.define('notify-me-slideout', NotifyMeSlideout)
